import { ApolloClient } from '@apollo/client';

import { MUTATION_DETACH_PAYMENT_METHOD } from '../apollo/api/mutations';
import { LIST_PAYMENT_METHODS } from '../apollo/api/queries';
import {
  GeneratedListPaymentMethodsQuery,
  GeneratedMutationDetachPaymentMethodMutation,
  GeneratedMutationDetachPaymentMethodMutationVariables,
  GeneratedPaymentMethod,
  GeneratedPaymentProvider,
} from '../types/generated';
import { PaymentGateway } from '../types/Payment';

export class AvantArtePaymentGateway implements PaymentGateway {
  constructor(private client: ApolloClient<any>) {}

  public async listPaymentMethods(): Promise<GeneratedPaymentMethod[]> {
    const result = await this.client.query<GeneratedListPaymentMethodsQuery>({
      query: LIST_PAYMENT_METHODS,
      fetchPolicy: 'no-cache',
    });

    if (result.data) {
      return result.data.listPaymentMethods;
    }

    return [];
  }

  public async detachPaymentMethod(
    id: string,
    providerId: GeneratedPaymentProvider,
  ): Promise<void> {
    await this.client.mutate<
      GeneratedMutationDetachPaymentMethodMutation,
      GeneratedMutationDetachPaymentMethodMutationVariables
    >({
      mutation: MUTATION_DETACH_PAYMENT_METHOD,
      variables: {
        id,
        providerId,
      },
    });
  }
}
